import { AnimatePresence, motion } from "motion/react"
import { IconArrowDownOutline18 as ArrowDown } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"

export const ScrollToLatest = ({
	isVisible,
	onClick,
	label,
	className,
}: {
	isVisible: boolean
	onClick: () => void
	label: string
	className?: string
}) => (
	<AnimatePresence>
		{isVisible && (
			<motion.button
				type="button"
				data-testid="scroll-to-latest"
				aria-label={label}
				title={label}
				onClick={onClick}
				initial={{ opacity: 0, y: 6, scale: 0.94 }}
				animate={{ opacity: 1, y: 0, scale: 1 }}
				exit={{ opacity: 0, y: 6, scale: 0.94 }}
				transition={{ duration: 0.18, ease: [0.23, 1, 0.32, 1] }}
				className={cn(
					"absolute bottom-3 left-1/2 z-20 flex size-8 -translate-x-1/2 items-center justify-center rounded-full bg-white text-primary shadow-lg ring-1 ring-black/[0.08] hover:bg-gray-50 dark:bg-gray-800 dark:ring-white/[0.14] dark:hover:bg-gray-750",
					className,
				)}
			>
				<ArrowDown className="size-4 flex-none" />
			</motion.button>
		)}
	</AnimatePresence>
)
